enum DocumentsCacheKeys {
  FIND_ALL_FOR_ORDER = 'documents.findAllDocumentsForOrder',
}

export const documentsQueryKeys = {
  byOrderId: (orderId: string) =>
    [DocumentsCacheKeys.FIND_ALL_FOR_ORDER, { orderId }] as const,
};
